module.exports = __webpack_public_path__ + "img/derek-veitch.cc2515c7.jpg";